import { Suspense, useEffect, useRef } from "react";
import { Outlet } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useIsMobile } from "@hooks/useIsMobile";
import { useHeader } from "@hooks/useHeader";
import useAxiosPrivate from "@hooks/useAxiosPrivate";

import PageTransition from "@components/transition.page";
import { ReactComponent as Logo } from "@assets/svg/showstage.svg";

import { LayoutProviders } from "./wrappers/wrapper.layoutProvider";
import { useLayoutEffects } from "./wrappers/wrapper.layouteffects";
import { lazy } from "react";

const Header=lazy(()=>import("@components/header.desktop"));
const MobileHeader=lazy(()=>import("@components/header.mobile"));
const Sidebar = lazy(() => import("@components/navbar.res"));
import MobileSlidebar from "@components/sidebar.mobile";


const Layout = () => {
  const isMobile = useIsMobile();
  const { scrollRef } = useHeader();
  const { axiosGet } = useAxiosPrivate();
  const { userId } = useSelector((s) => s.authReducer);
  const dispatch = useDispatch();
  const prevAxiosGet = useRef();

  

  useEffect(() => {
  console.log(
    "axiosGet changed:",
    prevAxiosGet.current !== axiosGet
  );

  prevAxiosGet.current = axiosGet;
}, [axiosGet]);

  useLayoutEffects({ dispatch, axiosGet, userId });

  return (
    <LayoutProviders>
      <Suspense fallback={null }>
        <MobileSlidebar />
        <MobileHeader />
      </Suspense>

      <div className="w-screen h-screen overflow-hidden d-flex relative lg:satic bg-white dark:!bg-gray-900">
        {isMobile ? (
          <Suspense fallback={null}>
            <Sidebar />
           </Suspense>
        ) : (
          <div className="w-[72px] d-none d-lg-flex flex-col align-items-center justify-start py-4 gap-[18px] bg-white dark:!bg-gray-900">
            <Logo />
            <Suspense fallback={null}>
              <Sidebar />
            </Suspense>
          </div>
        )}

        <div className="w-full lg:w-[calc(100%-72px)] h-full overflow-hidden">
          <Suspense fallback={null}>
            <Header />
          </Suspense>

          <div
            ref={scrollRef}
            className="bg-gray-100 dark:bg-black w-full lg:h-[calc(100%-70px)] h-full lg:p-5 overflow-y-scroll hidescrollbar lg:shadow-inner lg:rounded-tl-3xl"
          >
            <div className="bg-gray-100 md:bg-white pt-[65px] dark:!bg-gray-900 text-sec w-full lg:rounded-3xl lg:shadow-sm min-h-full lg:pt-0 overflow-hidden">
            <Suspense fallback={null}>
  <PageTransition>
    <Outlet />
  </PageTransition>
</Suspense>
            </div>
          </div>
        </div>
      </div>
    </LayoutProviders>
  );
};

export default Layout;
